import * as React from 'react';

function Time(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 18h-.33c-.65 0-1.279-.21-1.8-.6l-1.07-.8a2.996 2.996 0 00-3.6 0l-1.07.8c-.521.39-1.15.6-1.8.6H7v-.82c.03-1.8 1.41-3.34 3.311-3.93a.966.966 0 00.689-.94v-.62c0-.43-.27-.82-.689-.94C8.41 10.16 7.03 8.62 7 6.82V4h10v2.82c-.03 1.8-1.41 3.34-3.311 3.93a.966.966 0 00-.689.94v.62c0 .43.27.82.689.94 1.901.59 3.281 2.13 3.311 3.93V18zm1.5 2H18v-2.84c-.04-2.23-1.71-4.14-4-4.85v-.62c2.29-.71 3.96-2.62 4-4.84V4h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5s.22.5.5.5H6v2.84c.04 2.23 1.71 4.14 4 4.85v.62c-2.29.71-3.96 2.62-4 4.84V20h-.5c-.28 0-.5.22-.5.5s.22.5.5.5h13c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Time;
